export const getters = {
  getCidade: (state) => state.cidade,
  getCidades: (state) => state.cidades,
};

export default {};
